import {
  CurriculumProgressArray,
  GradeProgress,
  SubdivisionProgress,
  SubtopicProgress,
  TopicProgress,
} from '~/curriculum/types/curriculum-progress.type'
import { GradeOverviewFromSanity } from '~/curriculum/types/curriculum.types'

export function mergeProgressIntoGradeData(
  gradeData: GradeOverviewFromSanity | null,
  progressSummary: CurriculumProgressArray | undefined,
): GradeOverviewFromSanity | null {
  if (!gradeData || !progressSummary || progressSummary.length === 0) return gradeData

  const gradeProgressEntry = progressSummary.find((entry) => gradeData.gradeId in entry)
  const gradeProgress = gradeProgressEntry?.[gradeData.gradeId] as GradeProgress | undefined
  if (!gradeProgress || typeof gradeProgress === 'boolean') return gradeData

  const updatedGradeData: GradeOverviewFromSanity = { ...gradeData }
  const subDivisions = updatedGradeData.subDivisions.map((sd) => {
    const subDivisionId = sd._id
    if (!gradeProgress || typeof gradeProgress === 'boolean' || !gradeProgress[subDivisionId]) {
      return {
        ...sd,
        topics: sd.topics.map((topic) => ({
          ...topic,
          competencyGoals: topic.competencyGoals.map((cg) => ({ ...cg, isComplete: false })),
          isComplete: false,
        })),
      }
    }
    const subDivisionProgress = gradeProgress[subDivisionId] as SubdivisionProgress

    const topics = sd.topics.map((topic) => {
      const topicId = topic._id
      const topicProgress = subDivisionProgress.topics[topicId] as TopicProgress
      const competencyGoals = topic.competencyGoals.map((cg) => {
        const cgId = cg._id
        const competencyGoalsProgress = topicProgress?.subtopics[cgId] as SubtopicProgress
        const completeCount = competencyGoalsProgress
          ? Object.values(competencyGoalsProgress.summary || {}).filter((v) => v?.isComplete).length
          : 0
        return { ...cg, isComplete: competencyGoalsProgress?.isComplete, completeCount }
      })
      const topicCompleteCount = competencyGoals.reduce((sum, cg) => sum + (cg.isComplete ? 1 : 0), 0)

      return { ...topic, competencyGoals, isComplete: topicProgress?.isComplete, completeCount: topicCompleteCount }
    })
    return { ...sd, topics, isComplete: subDivisionProgress.isComplete }
  })

  return { ...updatedGradeData, subDivisions, isComplete: gradeProgress.isComplete }
}
